import angular from 'angular';

import GeneralSettingsComponent from './general.cmpt';

export default angular
    .module('application.scene.authorized.scene.settings.scene.general', [])
    .component(GeneralSettingsComponent.selector, GeneralSettingsComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('authorized.calendar.settings.general', {
        url: '/general',
        component: GeneralSettingsComponent.selector
    });
}



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/settings/scene/general/index.js